import React, { useEffect, useState } from 'react';
import './Navbar.scss';
import { getMenuItems } from '../../helpers/menuItems';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getUserInfo } from '../../helpers/localStorageHandler';

import NavBarIcons from './NavBarIcons';
import { useConfigurationContext } from 'store/configurationContext';
import { useHoliday } from 'store/HolidayContext';

const Navbar = () => {
	const { t } = useTranslation();
	const { comingHolidays, annoncements } = useHoliday();
	const { configurationState } = useConfigurationContext();
	const Company_Name = configurationState.find((item) => item.configKey === 'Company_Name')?.value || '';

	const location = useLocation();
	const userInfo = getUserInfo();
	const isLoggedIn = Boolean(userInfo?.userId);
	const isMerchant = Boolean(userInfo?.isMerchant);
	const menuItems = React.useMemo(() => getMenuItems(isLoggedIn, isMerchant), [isLoggedIn, isMerchant]);

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const companyLogo = configurationState.find((item) => item.configKey === 'company_logo')?.value || '';
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';

	return (
		<div
			style={{
				backgroundColor: themeColor,
				color: secondary_color,
				position: 'fixed',
				zIndex: 1000,
				width: '100%',
				top: comingHolidays.length || annoncements.length ? '35px' : '0px',
			}}
			className='mx-auto px-[15px] md:px-[75px]  pt-2 flex flex-col md:flex-row items-center justify-between'
		>
			{/* Logo and Menu Items */}
			<div className='flex flex-col md:flex-row items-center justify-between w-full md:w-auto'>
				<div className='flex justify-between xss:w-full md:w-auto min-h-[52px]'>
					{companyLogo && (
						<Link to={isLoggedIn ? '/merchants' : '/sign-in'} className='flex items-center'>
							<img src={companyLogo} alt='logo' className='h-fit' />
						</Link>
					)}
					{windowWidth < 768 && <NavBarIcons />}
				</div>
				{isLoggedIn && (
					<div className='flex md:items-center md:ml-3 w-[100%] xss:justify-around xss:mb-3 md:mb-0'>
						{menuItems.map((i) => (
							<Link
								id={`navbar_link_${i.key}`}
								style={{ color: secondary_color }}
								className={`text-sm font-medium text-white opacity-100 md:mx-5 hover:opacity-70  transition-all duration-300 ${
									location.pathname === `/${i.key}` ? 'underline' : 'no-underline'
								}`}
								to={i.key}
								key={i.key}
							>
								<span className='sm:hidden'>{t(i.mobileLabel)}</span>
								<span className='hidden sm:inline'>{t(i.label)}</span>
							</Link>
						))}
						{Company_Name.toLowerCase() === 'inzo' ? (
							<a
								href='https://my.inzo.co/login'
								target='_blank'
								rel='noreferrer'
								style={{ color: secondary_color }}
								className={`text-white text-sm font-medium opacity-95 flex justify-center md:mx-5 hover:opacity-70 hover:text-white transition-all duration-300 no-underline`}
							>
								<span className='sm:hidden'>{t('navTradersRoom')}</span>
								<span className='hidden sm:inline'>{t('tradersRoom')}</span>
							</a>
						) : null}
					</div>
				)}
			</div>
			{windowWidth >= 768 && <NavBarIcons />}
		</div>
	);
};

export default Navbar;
